// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"974d7bc9","122":"cd6d5768","256":"a6eada8e","398":"6d09995e","420":"f4c875fb","662":"2b32c0d7","700":"71eb1b08","844":"63a49e29","902":"cf118272"}[chunkId] + ".chunk.js";
};